import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { api } from './axios';

/**
 * Handler de erro para interceptor de response.
 * Quando o errorNormalizer é registrado primeiro, os handlers recebem sempre ApiRequestError.
 * Podem retornar uma resposta simulada (para recuperar) ou rejeitar (repassar o erro).
 */

export type ResponseErrorHandler = (
  error: unknown
) => Promise<AxiosResponse | void>;

/**
 * Handler para interceptor de request.
 * Recebe a config, pode modificá-la e deve retorná-la.
 */
export type RequestInterceptorHandler = (
  config: InternalAxiosRequestConfig
) => InternalAxiosRequestConfig;

/**
 * Registra um ou mais handlers de erro na response do axios.
 * Cada handler é executado em sequência quando ocorre um erro.
 *
 * @param interceptors - Handler único ou array de handlers de erro
 */
export const addResponseInterceptor = (
  interceptors: ResponseErrorHandler | ResponseErrorHandler[]
): void => {
  const handlers = Array.isArray(interceptors) ? interceptors : [interceptors];

  handlers.forEach((handler) => {
    api.interceptors.response.use((response) => response, handler);
  });
};

/**
 * Registra um ou mais handlers na request do axios.
 * Cada handler pode modificar a config antes da requisição ser enviada.
 *
 * @param interceptors - Handler único ou array de handlers
 */
export const addRequestInterceptor = (
  interceptors: RequestInterceptorHandler | RequestInterceptorHandler[]
): void => {
  const handlers = Array.isArray(interceptors) ? interceptors : [interceptors];

  handlers.forEach((handler) => {
    api.interceptors.request.use(handler);
  });
};
